import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cep',
})
export class CepPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '-';

    // Remove all non-numeric characters
    const numericValue = value.replace(/\D/g, '');

    // Handle CEP numbers with 8 digits
    if (numericValue.length === 8) {
      const part1 = numericValue.slice(0, 5);
      const part2 = numericValue.slice(5);
      return `${part1}-${part2}`;
    }

    // If not 8 digits, return the original or handle errors as necessary
    return value;
  }
}
